import { ref } from 'vue'
import { defineStore } from 'pinia'

import { useConfigStore }       from '@/stores/config'
import { useTranslaterStore }   from '@/stores/translater'
import { useRequestsStore }     from '@/stores/requests'
import { useTokenStore }        from '@/stores/token'
import { useProfileStore }      from '@/stores/profile'

export const useAuthStore = defineStore('auth', () => {

    const httpServer            = useConfigStore().httpServer
    const getTranslate          = useTranslaterStore().getTranslate
    const requestStore          = useRequestsStore()
    const tokenStore            = useTokenStore()
    const profileStore          = useProfileStore()

    const smartCaptchaId        = ref(null)
    const smartCaptchaScript    = ref(false)

    const auth                  = ref(false)
    const authProcess           = ref(false)
    const authMsg               = ref({})

    const requestCodeProcess    = ref(false)
    const requestCodeMsg        = ref({})

    const access_expired        = ref(null)
    const refresh_expired       = ref(null)

    const endUserSessionsProcess= ref(false)
    const endUserSessionsMsg    = ref({})

    /**
     * Отправляет запрос на авторизацию
     * 
     * @param {Object} payload - объект со значениями полей формы авторизации
     */
    async function sendAuth(payload) {

        authProcess.value = true

        const request = await requestStore.fetchRequest({
            address: `${ httpServer }/auth/login`, 
            method: 'POST', 
            data: payload
        })

        if(!request.error && request.user) {
            auth.value = true
            authMsg.value = { success: true }
            tokenStore.addToken(request)
            profileStore.setProfile(request.user)
        } else {
            auth.value = false
            authMsg.value = { success: false }
            authMsg.value.text = getTranslate[request.error] || request.error
        }

        authProcess.value = false
    }

    /**
     * Отправляет запрос на получения одноразового пароля
     * 
     * @param {Object} payload - объект со значениями полей формы запроса кода авторизации для одноразового входа
     */
    async function sendRequestCode(payload) {

        requestCodeProcess.value = true
        let result = false

        const request = await requestStore.fetchRequest({
            address: `${ httpServer }/auth/send_code`, 
            method: 'POST', 
            data: payload
        })

        if(!request.error) {
            requestCodeMsg.value = { success: true }
            result = true
        } else {
            requestCodeMsg.value = { success: false }
            requestCodeMsg.value.text = getTranslate[request.error] || request.error
        }

        requestCodeProcess.value = false
        return result
    }

    /**
     * Завершить все сеансы пользователя
     * 
     * @param {Object} payload - ID пользователя
     */
    async function endUserSessions(payload) {

        endUserSessionsProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestStore.fetchRequest({
                address: `${ httpServer }/auth/logoff/${payload}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                endUserSessionsMsg.value = { success: true, text: 'RESET_TOKEN_SUCCESS' }
            } else {
                endUserSessionsMsg.value = { success: false, text: request.error }
            }

        } else {
            endUserSessionsMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        endUserSessionsProcess.value = false
    }

    const setAuthMsg = data => authMsg.value = data
    const setRequestCodeMsg = data => requestCodeMsg.value = data
    const setSmartCaptchaScript = data => smartCaptchaScript.value = data
    const setSmartCaptchaId = data => smartCaptchaId.value = data

    return {

        smartCaptchaId,
        smartCaptchaScript,

        auth, 
        authProcess, 
        authMsg, 

        requestCodeProcess, 
        requestCodeMsg, 

        access_expired, 
        refresh_expired, 

        endUserSessionsProcess, 
        endUserSessionsMsg, 

        sendAuth, 
        sendRequestCode,
        endUserSessions, 
        setAuthMsg, 
        setRequestCodeMsg,
        setSmartCaptchaScript,
        setSmartCaptchaId
    }
})